@if (anchor) {
  <a [id]="anchor"></a>
}
<h2 kb-heading type="divider" [appEditorId]="editorIds?.boxHeadline">
  @if (attributes.boxHeadline) {
    {{ attributes.boxHeadline }}
  } @else {
    <ng-container i18n="info box heading@@314315645942131479">Info</ng-container>
  }
  @if (attributes.icon === 'info') {
    <kb-icon [icon]="iconInfo"></kb-icon>
  }
</h2>

<kb-card [attr.kb-color-variant]="attributes.backgroundColor === 'white' ? 'background' : attributes.backgroundColor === 'blue' ? 'primary' : undefined">
  @if (attributes.image) {
    <kb-picture
      slot="picture"
      [appOgImage]="attributes.image.attributes"
      [picture]="imageToPicture(attributes.image.attributes, attributes.numColumns === 4 ? standardAspectRatio : ultrawideAspectRatio).sources"
      [rootColumns]="attributes.numColumns"
      [alt]="attributes.image.attributes.alt"
      [variants]="[{aspectRatio: attributes.numColumns === 4 ? standardAspectRatio : ultrawideAspectRatio}]"
      [appEditorId]="attributes.image.editorIds?.src"
    ></kb-picture>
  }
  <div slot="content">
    @if (attributes.headline) {
      <h2 kb-heading [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
    }
    <kb-html [appEditorId]="editorIds?.text" kb-html [html]="attributes.text" ></kb-html>
  </div>
</kb-card>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
